import React from "react";
import "./Container.scss";

interface ContainerProps {
  maxHeight?: number;
  children: React.ReactNode;
  padding?: string;
}

export const Container = ({ maxHeight, children, padding = "0px" }: ContainerProps) => {
  const css = { padding };
  return (
    <div className="box-container" style={css}>
      {children}
    </div>
  );
};
